import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SHOW_SAVE_PAYMENT_CHECKBOX_CONFIG = createFcmDetails('show_save_payment_checkbox_config', {
	owner: 'United PD',
	context: 'Promote Page',
	description: 'Shows/Hides the save payment checkbox for available payment methods',
	import: false,
	template: {
		stripe: true,
		paypal: true,
	},
});
